import React, { useContext, useState } from "react";
import { useShopContext } from "../contexts/ShopContext";
//PinName, PinAmount, PinBox, PinPrice, PinImg

export default function Pin(props) {

  const SCart = useShopContext();
  const [showPlus, setShowPlus] = useState(false);
  const pinPlus = <div className="PinImgPlus"></div>;
  function PinClick() {
    if (showPlus){
      console.log("GetShopCart",SCart.getShopCart())
      AddToCart();
      console.log(SCart.ShopCart.length)
      setShowPlus(showPlus => !showPlus)
    } 
    else{
      setShowPlus(showPlus => !showPlus)
    }
  }

  function removePlus(){
    setShowPlus(showPlus => showPlus=false)
  }

  function AddToCart(){
    console.log("Adding item",props)
    SCart.AddItem(props);
  }
  
  return (
    <div className="Pin" >
      <div className="PinInfo" >
        <div className="PinName" onClick={removePlus}>{props.PinName}</div>
        <div className="PinNumbers" onClick={removePlus}>
          <div className="PinAmount">{props.PinAmount}st</div>
          <div className="PinBox">{props.PinBox}</div>
          <div className="PinPrice">{props.PinPrice}kr</div>
        </div>
        <div className="PinImg" onClick={PinClick}>
          <img src={require('../img/Pins/'+props.PinId+'.png')} alt="Baddare" />
          {showPlus && pinPlus }
        </div>
      </div>
    </div>
  );
}
